import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	placeholderSpork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	productDiscovery: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	softwareSpork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	serviceDesk: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	customerService: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	customerServiceManagement: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	businessSpork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	softwareSporkGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	businessSporkGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderSporkAppify: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholderSpork: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.placeholder-spork',
		defaultMessage: 'Filter by product',
		description: 'Placeholder that is showed inside the project type picker',
	},
	productDiscovery: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.product-discovery',
		defaultMessage: 'Jira Product Discovery',
		description: 'Placeholder that is showed inside the project type picker',
	},
	softwareSpork: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.software-spork',
		defaultMessage: 'Jira - software projects',
		description: 'Placeholder that is showed inside the project type picker',
	},
	serviceDesk: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.service-desk',
		defaultMessage: 'Jira Service Management',
		description: 'Placeholder that is showed inside the project type picker',
	},
	customerService: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.customer-service',
		defaultMessage: 'Jira Customer Service',
		description: 'Placeholder that is showed inside the project type picker',
	},
	customerServiceManagement: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.customer-service-management',
		defaultMessage: 'Customer Service Management',
		description: 'Placeholder that is showed inside the project type picker',
	},
	businessSpork: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.business-spork',
		defaultMessage: 'Jira - business projects',
		description: 'Placeholder that is showed inside the project type picker',
	},
	softwareSporkGalaxia: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.software-spork-galaxia',
		defaultMessage: 'Jira - software spaces',
		description: 'Placeholder that is showed inside the project type picker',
	},
	businessSporkGalaxia: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.business-spork-galaxia',
		defaultMessage: 'Jira - business spaces',
		description: 'Placeholder that is showed inside the project type picker',
	},
	placeholderSporkAppify: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-type-picker.placeholder-spork-appify',
		defaultMessage: 'Filter by app',
		description: 'Placeholder that is showed inside the project type picker',
	},
});
export default messages;
